import React from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

import { months, MenuProps, enMonths } from '../../Assets/js/constant';

function MonthSelector({
  selectedMonths,
  defaultStartMonth,
  onChange
}) {
  const handleChange = (event) => {
    const newMonths = event.target.value;

    let _selectedMonths = [], _label;
    _label = newMonths.toString();
    _selectedMonths[0] = newMonths;

    onChange({
      selectedMonths: _selectedMonths,
      month_label: _label,
    });
  };

  return (
    <FormControl sx={{ marginTop: '3px' }} variant="standard">
      <Select
        sx={{
          width: 100,
          '& .MuiSelect-selectMenu': {
            height: 33,
            display: 'flex',
            alignItems: 'center',
            paddingTop: 0,
            paddingBottom: 0,
            fontWeight: 'bold',
            fontFamily: 'Verdana !important',
            fontSize: '10pt',
          }
        }}
        value={selectedMonths.length !== 0 ? selectedMonths : [1]}
        onChange={handleChange}
        MenuProps={MenuProps}
      >
        {months &&
          months.map((month, idx) => (
            <MenuItem
              key={month}
              value={month}
              sx={{
                padding: '2px 5px',
                fontFamily: 'Verdana',
              }}
            >
              {month + ' - ' + enMonths[(idx + defaultStartMonth - 1) % 12]}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}

MonthSelector.propTypes = {
  selectedMonths: PropTypes.array.isRequired,
  month_label: PropTypes.string.isRequired,
  defaultStartMonth: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default MonthSelector;
